import { connect } from 'react-redux';
import { Placement } from '@noths/polaris-client-ribbons-design-system';

import { addItemToBasket } from 'src/redux/basket';
import { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  actions as personalisationActions,
  InteractionErrorTrackingEvent,
  selectOutstandingPersonalisations,
  selectPersonalisationFromBasket,
  submitPersonalisationForm,
} from 'src/redux/personalisation';
import { actions as productActions } from 'src/redux/product';
import { actions as reviewsActions } from 'src/redux/reviews';
import { selectFavouriteProduct, selectProductDeliveryByEvent } from 'src/redux/selectors';
import { AppThunkDispatch } from 'src/redux/store';
import { getClientLogger } from 'src/utils/clientLogger';
import { ProductInfo } from '../components/ProductInfo';
import { ON_CART_GO_TO_BASKET_WARN } from '../constants/logging';
import { actions } from '../modules';
import { GAEventsMap } from '../tracking/eventsMap';

export const ON_CART_GO_TO_BASKET_TIMEOUT = 5000;

const onCartGoToBasket = () => {
  getClientLogger().warn(ON_CART_GO_TO_BASKET_WARN);
  /* 
    Applying a short circuit to bypass the redux middleware and call the GAEventsMap directly for onCartGoToBasket.
    This is to ensure a redirect to cart page as there is a bug with middleware sometimes not firing:
    https://notonthehighstreet.atlassian.net/wiki/spaces/F/pages/3430940681/FFA-1564
  */
  // @ts-ignore
  GAEventsMap[actions.onCartGoToBasket.type]();
};

const mapStateToProps = (state: ReduxApplicationState) => ({
  basket: state.basket.basket,
  deliveryByEvent: selectProductDeliveryByEvent(state),
  editItem: selectPersonalisationFromBasket(state),
  hasAddToBasketErrors: !!state.basket.error,
  hideAddToCartPlacement: state.richRelevance?.[Placement.AddToCart]?.products === null,
  isBasketRequestPending: state.basket.isPending,
  isCartModalOpen: state.productInfo.isCartModalOpen,
  isPersonalisationOptionsExpanded: state.personalisation.isPersonalisationOptionsExpanded,
  outstandingSelections: selectOutstandingPersonalisations(state),
  product: selectFavouriteProduct(state),
  richRelevanceSessionId: state.userConfiguration.richRelevanceSessionId,
  shouldShowPersonalisationValidationErrors:
    state.personalisation.shouldShowPersonalisationValidationErrors,
  trackedEvents: state.personalisation.trackedEvents,
  userConfiguration: state.userConfiguration,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  addToBasket: () => dispatch(addItemToBasket()),
  changeQuantity: (payload: { quantity: number; isValid: boolean }) =>
    dispatch(productActions.changeQuantity(payload)),
  toggleExpanded: () => dispatch(personalisationActions.toggleExpanded()),
  openCartModal: () => dispatch(actions.openCartModal()),
  trackErrorInteraction: (payload: InteractionErrorTrackingEvent) =>
    dispatch(personalisationActions.trackInteractionError(payload)),
  onCartGoToBasket: () => {
    setTimeout(onCartGoToBasket, ON_CART_GO_TO_BASKET_TIMEOUT);
    dispatch(actions.onCartGoToBasket());
  },
  onCartModalClose: () => {
    dispatch(actions.closeCartModal());
    dispatch(actions.onCartContinueShopping());
  },
  onCrossSellModalClose: () => {
    dispatch(actions.onCartContinueShopping());
  },
  onProductReviewsReadReviews: () => dispatch(reviewsActions.onProductReviewsReadReviews()),
  submitPersonalisationForm: () => dispatch(submitPersonalisationForm()),
});

export const ProductInfoContainer = connect(mapStateToProps, mapDispatchToProps)(ProductInfo);
